/**
 * Structure FAQs in the Schema.org FAQPage format
 * @param {Array} faqs - Array of objects with properties `top` (question) and `content` (answer)
 * @returns {Object|null} - Structured object for Schema.org FAQPage or null if no FAQs
 */
export const structureFaqs = faqs => {
  if (!faqs.length) {
    return null;
  }

  const content = faqs.map(faq => ({
    '@type': 'Question',
    name: faq.top,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.content
    }
  }));

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: content
  };
};
